export enum InputStateType {
  Failed = 'error',
  Success = 'valid',
}
